export const locale = {
    lang: 'ru',
    data: {
        'QUEUE': {
            'LEAD': 'Лид',
            'WARN_MSG': ' Вы еще не обработали текущего лида!',
            'GET_NEXT': 'Следующий',
            'STOP': 'Остановить',
            'WAITIN_MSG': 'Ожидание нового лида'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/main/lead-queue-pannel/i18n/ru.ts